<template>
  <div class="video">
    <a-row :gutter="12">
      <a-col :md="6" :sm="8" :lg="4">
        <div style="padding-top:25px;padding-left:15px">
          <input type="text" v-model="condition" class="input" :placeholder="placeholder" @keyup.enter="search" />
          <div class="btns btns-2">
            <img class="qh" @click="changeHttp" src="../../../public/qh2.png" alt="切换请求类型" title="切换请求类型" />
          </div>
          <div class="btns">
            <img class="cz" @click="getSurveillanceTree" src="../../../public/cz.png" alt="重置" title="重置" />
          </div>
          <a-tree
            style="height: 83vh; margin-top: 20px; overflow: scroll; max-width: 310px; z-index: -1"
            :treeData="productTree"
            :showLine="true"
            @expand="onExpand"
            :expandedKeys="expandedKeys"
            @select="onTreeSelect"
          ></a-tree>
        </div>
        <div class="gongge" @click="showType = !showType">
          <img src="../../../public/gezi.png" alt="" style="width: 20px; height: 20px" />
        </div>
        <div v-if="showType" class="p-box">
          <ul>
            <li @click="changeType(1)">
              <img src="../../../public/g-1.png" alt="" style="width: 20px; height: 20px; margin-right: 5px" />1x1
            </li>
            <li @click="changeType(2)">
              <img src="../../../public/g-2.png" alt="" style="width: 20px; height: 20px; margin-right: 5px" />2x2
            </li>
            <li @click="changeType(3)">
              <img src="../../../public/g-3.png" alt="" style="width: 20px; height: 20px; margin-right: 5px" />3x3
            </li>
          </ul>
        </div>
      </a-col>
      <a-col :md="18" :sm="16" :lg="20">
        <div style="height: 83vh">
          <div class="video-item" v-if="videoType == 1">
            <div
              class="video-list-1"
              v-for="(item, index) in videoNowList[0]"
              :key="index"
              @click="changeN(0, index)"
              :class="{ bd: numList[0] == 0 && numList[1] == index }"
            >
              <img v-if="!item" src="../../../public/camera.png" alt="" style="width: 64px; height: 64px" />
              <iws-video
                v-else
                :styleType="2"
                :width="1571"
                :height="777"
                :linkId="item.linkId"
                :siteId="item.linkId"
                :selectType="item.selectType"
                :device-serial="item.serial"
                :channel="item.channel"
                :device-type="parseInt(item.deviceType)"
                :device-name="item.deviceName"
                :type="parseInt(item.type)"
                :autoplay="item.autoplay == '1' ? item.autoplay : '0'"
              ></iws-video>
              <div v-if="!item" class="videoP">请选择视频位置</div>
              <div v-if="item" class="deleteText" title="撤销" @click="changeN(0, index)">
                <a-icon type="rollback" :style="{ fontSize: '28px' }" />
              </div>
            </div>
          </div>
          <div class="video-item" v-else-if="videoType == 2">
            <div
              class="video-list-2"
              v-for="(item, index) in videoNowList[1]"
              :key="index"
              @click="changeN(1, index)"
              :class="{ bd: numList[0] == 1 && numList[1] == index }"
            >
              <img v-if="!item" src="../../../public/camera.png" alt="" style="width: 64px; height: 64px" />
              <iws-video
                v-else
                :styleType="2"
                :width="782"
                :height="385"
                :linkId="item.linkId"
                :siteId="item.linkId"
                :selectType="item.selectType"
                :device-serial="item.serial"
                :channel="item.channel"
                :device-type="parseInt(item.deviceType)"
                :device-name="item.deviceName"
                :type="parseInt(item.type)"
                :autoplay="item.autoplay == '1' ? item.autoplay : '0'"
              ></iws-video>
              <div v-if="!item" class="videoP">请选择视频位置</div>
              <div v-if="item" class="deleteText" title="撤销" @click="changeN(1, index)">
                <a-icon type="rollback" :style="{ fontSize: '28px' }" />
              </div>
            </div>
          </div>
          <div class="video-item" v-else>
            <div
              class="video-list-3"
              v-for="(item, index) in videoNowList[2]"
              :key="index"
              @click="changeN(2, index)"
              :class="{ bd: numList[0] == 2 && numList[1] == index }"
            >
              <img v-if="!item" src="../../../public/camera.png" alt="" style="width: 64px; height: 64px" />
              <iws-video
                v-else
                :styleType="2"
                :width="520"
                :height="255"
                :linkId="item.linkId"
                :siteId="item.linkId"
                :selectType="item.selectType"
                :device-serial="item.serial"
                :channel="item.channel"
                :device-type="parseInt(item.deviceType)"
                :device-name="item.deviceName"
                :type="parseInt(item.type)"
                :autoplay="item.autoplay == '1' ? item.autoplay : '0'"
              ></iws-video>
              <div v-if="!item" class="videoP">请选择视频位置</div>
              <div v-if="item" class="deleteText" title="撤销" @click="changeN(2, index)">
                <a-icon type="rollback" :style="{ fontSize: '28px' }" />
              </div>
            </div>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { surveillanceTree, selectVideos } from '@/api/api'
import IwsVideo from '@comp/VideoPlay/IwsVideo'
import { isNumber } from 'util'

export default {
  components: {
    IwsVideo,
  },
  data() {
    return {
      productTree: [],
      videoType: 1,
      showType: false,
      treeData: [],
      selectedKeys: [], //设置选中的树节点
      checkedKeys: [],
      autoExpandParent: true,
      expandedKeys: [],
      visiable: true,
      condition: '',
      numList: [],  //第一个参数是九宫格的类型  第二个参数是九宫格内对应的视频的位置
      queryType: 1,
      placeholder: '模糊查询',
    }
  },
  created() {
    this.videoType = window.sessionStorage.getItem('videoType') ? window.sessionStorage.getItem('videoType') : 1
    this.numList[0] = Number(this.videoType) - 1
    this.getSurveillanceTree()
    console.log(JSON.parse(window.sessionStorage.getItem('videoNowList')))
    this.videoNowList = JSON.parse(window.sessionStorage.getItem('videoNowList'))
      ? JSON.parse(window.sessionStorage.getItem('videoNowList'))
      : [[null], [null, null, null, null], [null, null, null, null, null, null, null, null, null]]
    if (JSON.parse(window.sessionStorage.getItem('videoNowList'))) {
      for (let index = 0; index < this.videoNowList[Number(this.videoType) - 1].length; index++) {
        if (!this.videoNowList[Number(this.videoType) - 1][index]) {
          this.numList[1] = index
          return
        } else {
          this.numList[1] = 0
        }
      }
    }

  },
  mounted() {},
  methods: {
    changeType(val) {
      window.sessionStorage.setItem('videoType', val)
      this.videoType = val
      this.numList[0] = Number(this.videoType) - 1
      this.numList[1] = null
      this.showType = false
    },
    changeHttp() {
      if (this.queryType == 1) {
        this.queryType = 3
        this.placeholder = '序列号查询'
      } else if (this.queryType == 3) {
        this.queryType = 1
        this.placeholder = '模糊查询'
      }
    },
    getSurveillanceTree() {
      surveillanceTree().then((res) => {
        if (res.success) {
          this.productTree = [...res.result]
        }
      })
    },
    onTreeSelect(selectedKeys, e, data) {
			console.log('this.numList',this.numList)
			console.log('this.videoNowList',this.videoNowList)
			this.selectedKeys = selectedKeys
      let t = e.selectedNodes[0].data.props
      let token = window.sessionStorage.getItem('token')
      let num = []
      if (t.serial) {
        if (typeof this.numList[0] == 'number' && typeof this.numList[1] != 'number') {
          //当没有选中视频位置时
		  for(let i = 0;i<this.videoNowList[this.numList[0]].length;i++){
			  let e = this.videoNowList[this.numList[0]][i]
			  if (!e) {
			    num = [i]
				break
			  }
		  }
		  // this.videoNowList[this.numList[0]].forEach((e, i) => {
    //         if (!e) {
    //           num = [i]
    //           return false
    //         }
    //         // else {
    //         //   num = [0]
    //         // }
    //       })
        } else if (typeof this.numList[0] == 'number' && typeof this.numList[1] == 'number') {
          num = [this.numList[1]]
        }
        console.log(typeof this.numList[1], this.numList[1], num)
        this.videoNowList[this.numList[0]][num[0]] = t
        // this.videoNowList.map(e=> {
        //   e.map(v=> {
        //     if(v &&v.autoplay && v.autoplay=='1') {
        //       v.autoplay='0'
        //     }
        //   })
        // })
        window.sessionStorage.setItem('videoNowList', JSON.stringify(this.videoNowList))
        this.videoNowList[this.numList[0]][num[0]].autoplay = '1'
        this.$forceUpdate()
      }
    },
    onExpand(expandedKeys, isText) {
      console.log('onExpand', expandedKeys)
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    search() {
      console.log(this.condition)
      selectVideos({ condition: this.condition, queryType: this.queryType }).then((res) => {
        if (res.success) {
          this.productTree = [...res.result]
        }
      })
    },
    changeN(num1, num2) {
      console.log(num1, num2)
      this.numList = [num1, num2]
      if (this.videoNowList[num1][num2]) {
        this.videoNowList[num1][num2] = null
        window.sessionStorage.setItem('videoNowList', JSON.stringify(this.videoNowList))
        this.$forceUpdate()
      }
    },
  },
}
</script>
<style lang="scss" scope>
.bd {
  border: 3px solid #24aedb !important;
}
.video {
  /deep/ .ant-card {
    width: 308px;
  }
}
.input {
  position: absolute;
  top: 5px;
  left: 30px;
  width: 65%;
  line-height: 28px;
  border-radius: 4px;
  border: 1px solid #ccc;
  padding-left: 10px;
  box-shadow: 1px 1px 0px #ccc;
}
.btns {
  position: absolute;
  left: 80%;
  top: 10px;
  .cz {
    width: 22px;
    height: 22px;
    margin-right: 8px;
  }
  .cz:active {
    background-color: #9cdcfe;
  }
  .qh:active {
    background-color: #9cdcfe;
  }
  .qh {
    width: 26px;
    height: 26px;
    margin-right: 4px;
  }
}
.btns-2 {
  left: 65%;
}
.p-box ul {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 70px;
}
.p-box li {
  line-height: 30px;
  text-align: center;
}
.gongge {
  position: absolute;
  top: 10px;
  right: 8px;
}
.p-box {
  position: absolute;
  right: -72px;
  top: 0;
  background-color: #fff;
  z-index: 1;
  border-radius: 5px;
}
.video-item {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  height: 777px;
  width: 1571px;
  background-color: #fff;
}
.videoP {
  font-size: 16px;
  color: #777;
}
.deleteText {
  position: absolute;
  top: 3px;
  right: 70px;
  z-index: 1000000;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s ease;
  background: rgba(0, 0, 0, 0.45);
  border-radius: 4px;
  padding: 2px 6px;
}
.video-list-1:hover .deleteText,
.video-list-2:hover .deleteText,
.video-list-3:hover .deleteText {
  opacity: 1;
}
.video-list-1 {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1571px;
  height: 777px;
  background-color: #aaa;
  border: 3px solid transparent;
  // box-sizing: content-box;
}
.video-list-2 {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 782px;
  height: 385px;
  background-color: #aaa;
  border: 3px solid transparent;
  // box-sizing: content-box;
}
.video-list-3 {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 520px;
  height: 255px;
  background-color: #aaa;
  border: 3px solid transparent;
  // box-sizing: content-box;
}
.ant-tree li .ant-tree-node-content-wrapper{
  color: #1890FF;
}
.ant-tree.ant-tree-show-line li span.ant-tree-switcher {
    background:none;
    color: #1890FF;
}
.ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background-color: #1890FF;
    color: #FFFFFF;
}
.ant-tree li .ant-tree-node-content-wrapper:hover {
   background-color: #1890FF;
    color: #FFFFFF;
}
.ant-tree.ant-tree-show-line li:not(:last-child):before {
    content: ' ';
    width: 1px;
    border-left: 0px solid #00ffff;
    height: 100%;
    position: absolute;
    left: 12px;
    margin: 22px 0;
}
</style>


